import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ApiDataResponse, BaseApiDataResponse } from '../Models/ApiData';
import {
    Materiel,
    MaterielDetailsApiDataResponse,
    MaterielListOrder,
    MaterielListResponse,
} from '../Models/Materiels/Materiel';
import { BaseDataService } from './Base/BaseDataService';

export const MaterielEndpoints = {
    MATERIELS: '/api/v1/back/materiels',
    MATERIEL: (materielId: string) => `/api/v1/back/materiels/${materielId}`,
    UPDATE_MATERIEL: (materielId: string) => `/api/v1/back/materiels/${materielId}`,
    CREATE_MATERIEL: '/api/v1/back/materiels',
    EXPORT_MATERIEL_LIST: '/api/v1/back/materiels/export',
};

export interface IMaterielDataService {
    listMateriel: (
        params: {
            search?: string;
            order?: MaterielListOrder;
            is_actif?: boolean;
        },
        cts: XHRRequestCanceler
    ) => Promise<MaterielListResponse>;

    getMateriel: (
        cts: XHRRequestCanceler,
        materielId: string
    ) => Promise<MaterielDetailsApiDataResponse>;

    updateMateriel: (
        materielId: string,
        materiel: Materiel,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    createMateriel: (
        materiel: Materiel,
        cts: XHRRequestCanceler
    ) => Promise<ApiDataResponse<string>>;
}

class MaterielDataService extends BaseDataService implements IMaterielDataService {
    listMateriel = async (
        params: {
            search?: string;
            order?: MaterielListOrder;
            is_actif?: boolean;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<MaterielListResponse>(MaterielEndpoints.MATERIELS, cts, {
            params,
        });
    };

    getMateriel = async (cts: XHRRequestCanceler, materielId: string) => {
        return this.get<MaterielDetailsApiDataResponse>(
            MaterielEndpoints.MATERIEL(materielId),
            cts
        );
    };

    updateMateriel = async (materielId: string, materiel: Materiel, cts: XHRRequestCanceler) => {
        const body = {
            ...materiel,
        };
        return this.patch(MaterielEndpoints.UPDATE_MATERIEL(materielId), body, cts);
    };

    createMateriel = async (materiel: Materiel, cts: XHRRequestCanceler) => {
        const body = {
            ...materiel,
        };
        return this.post<ApiDataResponse<string>>(MaterielEndpoints.CREATE_MATERIEL, body, cts);
    };
}

const MaterielDataServiceName = 'MaterielDataService';
export { MaterielDataService, MaterielDataServiceName };
